import React, { useEffect, useState } from 'react';
import { fehlertext } from '../lib/fehlertext';
import { assistantAPI } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Bot, Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export function AssistantLimitsSettings() {
  const [perDay, setPerDay] = useState(25);
  const [saving, setSaving] = useState(false);

  useEffect(function loadLimits() {
    assistantAPI.getLimits().then(function onOk(r) {
      setPerDay(r.data.messages_per_day ?? 25);
    }).catch(function onErr() {});
  }, []);

  const save = async function doSave() {
    setSaving(true);
    try {
      await assistantAPI.setLimits(Number(perDay));
      toast.success('Assistent-Limit gespeichert.');
    } catch (e) {
      toast.error(fehlertext(e, 'Speichern fehlgeschlagen.'));
    } finally { setSaving(false); }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Bot className="h-5 w-5" />
          Assistent - Nachrichten-Limit
        </CardTitle>
        <CardDescription>
          Wie viele Chat-Nachrichten ein Verwaltungsnutzer pro Tag senden darf. Admin und Geschäftsführung sind immer unbegrenzt; dieses Limit gilt für Backoffice, Personalmanager und Koordinator.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-3">
          <Label className="text-sm text-slate-600 w-44">Nachrichten pro Tag</Label>
          <Input type="number" min="1" max="1000" value={perDay}
            onChange={function onChange(e) { setPerDay(e.target.value); }}
            className="w-24"
            data-testid="assistant-limit-input" />
        </div>
        <div className="flex justify-end">
          <Button onClick={save} disabled={saving} className="bg-blue-800 hover:bg-blue-900"
            data-testid="assistant-limit-save">
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
            Speichern
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
